import script from "./ClassComparisonBarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassComparisonBarChart.vue?vue&type=script&setup=true&lang=js"

import "./ClassComparisonBarChart.vue?vue&type=style&index=0&id=6c24e015&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c24e015"]])

export default __exports__